import _ from 'lodash';
import angular from 'angular';

function FormHelpersServiceFn() {
  class FormHelpersService {
    /**
     * @desc Gets error messages from an Angular form
     * @param {Object} form - Angular form object
     * @return Array<String> - array of string errors
     */
    getFormErrors(form) { //eslint-disable-line
      if (!form) throw new Error('formHelpersService - getFormErrors() - form is required');

      const errors = [];

      if (form.$error && form.$error.required) {
        _.each(form.$error.required, requiredField => {
          errors.push(`${requiredField.$name} is required`);
        });
      }

      return errors;
    }

    /**
     * @desc Creates a hash of all the input values that were changed in a form
     * @param {Object} form - Angular form object
     * @return Object
     */
    getChangedFormValues(form) { //eslint-disable-line
      if (!form) throw new Error('formHelpersService - getChangedFormValues() - form is required');

      const changedValues = {};

      angular.forEach(form, (value, key) => {
        if (!key || key[0] === '$') return;

        if (value.$dirty || !value.$untouched) {
          changedValues[key] = value.$modelValue === '' ? null : value.$modelValue;
        }
      });

      return changedValues;
    }
  }

  return new FormHelpersService();
}

FormHelpersServiceFn.$inject = [];

export default FormHelpersServiceFn;



// WEBPACK FOOTER //
// ./src/services/formHelpersService.js